import React, { useState } from 'react'
import { Container, Box, Typography, Button } from '@mui/material'
import heroimg from "../assets/hero.png"
import DraftsIcon from '@mui/icons-material/Drafts';
import logoimg from "../assets/logo.png"
import { API_BASE_URL } from '../components/Config';
import axios from "axios";
import { useNavigate } from 'react-router-dom';
import { useSnackbar } from "notistack";


const ForgetPassword = () => {

const [email ,setEmail]= useState("")
const navigate = useNavigate()
const { enqueueSnackbar } = useSnackbar();




const handelForgetAPIFunc = async()=>{

  try {
    const data = {email:email}
    localStorage.setItem("email",email)
    const res = await axios.post(`${API_BASE_URL}/accounts/user/forget_password/`,data)
    if(res?.data?.message){
      enqueueSnackbar(res?.data?.message, { variant: "success" });
      navigate("/EnterCode")
    }
    console.log(res)
  } catch (error) {
    console.log(error)
  }
}

  return (
    <>
          <div className='back_Login'>
                <Container maxWidth="xl" className='login_container'>
                    <Box className='Login_image'>
                        <img src={heroimg} alt="images" />
                    </Box>
                    <Box className="form_Login">
                    <img src={logoimg} alt="" className='logo_login'/>
                        <Box>
                            <Typography variant="h3">Forgot Password?</Typography>
                            <p className='login_p'>Don’t worry! It happens. Please enter the email associated with your account.</p>
                        </Box>
                        <Box className="inputs_div">
                            <Box className="input_filde_divs"><input type="email" placeholder='Type email' onChange={(e)=>setEmail(e.target.value)}/>
                             <Box className="Login_icon"><DraftsIcon sx={{paddingRight:"2px"}} /></Box></Box>
                          
                        </Box>
                        <Box>
                  <Button variant="contained" className='Login_btn  mt-3' onClick={handelForgetAPIFunc}>
                    Send Code
                      </Button>
                    </Box>

                    </Box>
                </Container>
            </div>  
    </>
  )
}

export default ForgetPassword
